import { DEAL_ACTIVITY } from './dealActivityEvent';
import { DEAL_ACTIVITY_EVENTS_LISTING } from './dealActivityEventsListing';

import { RE_DATE_DEAL_EVENT_ACTIVITIES } from './reDateDealEventActivities';
import { COMPLETE_DEAL_EVENT_ACTIVITIES } from './completeDealEventActivities';

export * from './types';
export * from './usaCalendar';

export const calendarApi = {
  dealActivityEventsListing: DEAL_ACTIVITY_EVENTS_LISTING,
  dealActivity: DEAL_ACTIVITY,

  reDate: RE_DATE_DEAL_EVENT_ACTIVITIES,
  complete: COMPLETE_DEAL_EVENT_ACTIVITIES,
};
